module.exports = __webpack_public_path__ + "img/318.945153fa.png";